export const REPORT_MAX_DAYS_DIFFERENCE = 90
export const REPORT_MAX_POLICY_NUMBER_LENGTH = 50
export const REPORT_MAX_SUB_POLICY_HOLDER_LENGTH = 50
export const REPORT_MAX_INSURANCE_TYPE_LENGTH = 50
export const REPORT_MAX_GROUP_TYPE_LENGTH = 50
export const REPORT_MAX_ENDORSEMENT_LENGTH = 50
export const REPORT_MAX_CUSTOMER_FULL_NAME_LENGTH = 50
export const REPORT_MAX_BROKER_NAME_LENGTH = 50
export const FULL_NAME_MAX_LENGTH = 100
